export function tokenize(input: string) {
  return input
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // remove diacritics
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9]+/g, '-') // remove non-alphanumeric characters except hyphens
    .replace(/^-+|-+$/g, ''); // trim leading and trailing hyphens
}
